<section class="w-full">

     <app-banner_section-type01
          [options]="{ title: '', imageHref:view.imageHref }"></app-banner_section-type01>

     <div class="max-w-lg md:max-w-2xl flex flex-col justify-center items-center mx-auto">
          <!-- Header (Title/Tagline) section -->
          <div class="mb-8 flex flex-col items-center justify-center text-center">
               <!-- <h4 class="text-base text-primry-600 font-semibold tracking-wide uppercase">Our Promotional Section</h4> -->
               @if(view.site?.id !== 77) {
                    <p class="mt-2 text-2xl md:text-5xl lg:text-7xl font-light font-primary tracking-wide text-gray-900 dark:text-gray-200">The Travel Experts</p>
                    <img class="w-50 md:w-100" src="assets/xltravel/swoosh-01.svg" alt="xl underline">
               }
               @if(view.site?.id === 77) {
                    <p class="mt-2 text-xl md:text-5xl lg:text-7xl font-light font-primary tracking-wide text-gray-900 dark:text-gray-200">Meet Your Travel Expert</p>
                    <img class="w-50 md:w-100" src="assets/xltravel/swoosh-01.svg" alt="xl underline">
               }
          </div>
          <div class="flex justify-center px-5">
               @if(view.site?.id !== 77){
                    <p class="text-md md:text-lg text-center mb-15 max-w-lh">Our Consultants pride themselves with dedication, passion and team work. Their fast pace and attention to detail make them experts.</p>
               }
               @if(view.site?.id === 77){
                    <p class="text-md md:text-lg text-center mb-15 max-w-lh">With over 25 years of industry experience, I’ve been helping clients craft unforgettable travel experiences since 2018 - right here as a one-woman business in Bloemfontein. From flights and tours to cruises and travel insurance, I offer personalized service with expert advice and unbeatable deals. Your journey matters, and I’m here to make it seamless, exciting, and stress-free-every step of the way.</p>
               }
          </div>
     </div>
     @if(view.site?.id === 86) {
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-15 mb-20">
               <div *ngFor="let member of teamMembers"
                    class="bg-white shadow-lg rounded-lg pb-6 text-center flex flex-col h-full">
                    <img [src]="member.img" alt="{{ member.name }}" class="mx-auto w-full h-64 object-cover object-top mb-4">
                    <h3 class="text-lg font-semibold text-gray-700 pb-2">{{ member.name }} {{ member.lastName }}</h3>
                    <p class="text-gray-500 text-sm px-3">{{ member.about }}</p>
                    <div class="mt-auto">
                         <button (click)="sendEmail(member.email)"
                              class="mt-4 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-primary-100 cursor-pointer hover:text-primary-500 transition-all duration-300">Email me</button>
                    </div>
               </div>
          </div>
     }
     @if(view.site?.id === 113) {
     <div class="px-15">
          <img src="/assets/images/avatars/XL-ESWATINI-TEAM.jpg" alt="Team Photo"
               class="hidden md:flex mx-auto rounded-xl md:h-140 lg:h-160 object-cover object-center mb-4" />
     </div>
     <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-15 mb-20">
          <div *ngFor="let member of teamEswatini"
               class="bg-white shadow-lg rounded-lg pb-6 text-center flex flex-col h-full">
               <h3 class="text-lg font-semibold text-gray-700 pb-2 pt-2">{{ member.name }} {{ member.lastName }}</h3>
               <p class="text-gray-500 text-sm px-3">{{ member.about }}</p>
               <!-- <div class="mt-auto">
                    <button (click)="sendEmail(member.email)"
                         class="mt-4 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-primary-100 cursor-pointer hover:text-primary-500 transition-all duration-300">Email
                         me</button>
               </div> -->
          </div>
     </div>
     }
     @if(view.site?.id === 77) {
     <div class="w-full grid grid-cols-1 justify-items-center px-15 mb-20">
          <div *ngFor="let member of teamBloem" class="bg-white shadow-lg rounded-lg pb-6 text-center flex flex-col h-full">
               <img [src]="member.img" alt="{{ member.name }}" class="mx-auto w-full h-64 object-cover object-top mb-4">
               <h3 class="text-lg font-semibold text-gray-700 pb-2">{{ member.name }} {{ member.lastName }}</h3>
               <p class="text-gray-500 text-sm px-3">{{ member.about }}</p>
               <div class="mt-auto">
                    <button (click)="sendEmail(member.email)"
                         class="mt-4 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-primary-100 cursor-pointer hover:text-primary-500 transition-all duration-300">Email me</button>
               </div>
          </div>
     </div>
     }
     @if(view.site?.id === 98) {
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-15 mb-20">
               <div *ngFor="let member of teamCenturion"
                    class="bg-white shadow-lg rounded-lg pb-6 text-center flex flex-col h-full">
                    <img [src]="member.img" alt="{{ member.name }}" class="mx-auto w-full h-96 object-cover object-top mb-4">
                    <h3 class="text-lg font-semibold text-gray-700 pb-2">{{ member.name }} {{ member.lastName }}</h3>
                    <p class="text-md text-primary-500 pb-2">{{member.title}}</p>
                    <p class="text-gray-500 text-sm px-3">{{ member.about }}</p>
               </div>
          </div>
     }
     @if(view.site?.id === 88 || view.site?.id === 96) {
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-15 mb-20">
               <div *ngFor="let member of teamMembersElite"
                    class="bg-white shadow-lg rounded-lg pb-6 text-center flex flex-col h-full">
                    <img [src]="member.img" alt="{{ member.name }}" class="mx-auto w-full h-72 object-cover object-center mb-4">
                    <h3 class="text-lg font-semibold text-gray-700 pt-2">{{ member.name }} {{ member.lastName }}</h3>
                    <p class="text-md italic py-2">{{ member.title }}</p>
                    <p class="text-gray-500 text-sm px-3">{{ member.about }}</p>
                    <div class="mt-auto">
                         <button (click)="sendEmail(member.email)"
                              class="mt-4 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-primary-100 cursor-pointer hover:text-primary-500 transition-all duration-300">Email me</button>
                    </div>
               </div>
          </div>
    }
</section>